// extracted by mini-css-extract-plugin
export default {"root":"StudentDiscountSignupMessage_root__GIP4w","title":"StudentDiscountSignupMessage_title__TAluX","description":"StudentDiscountSignupMessage_description__gahPT"};